export default __webpack_public_path__ + "static/media/robot_icon.aa5e7715.png";